<div class="kanban-wrap">
  <div class="kanban-scroller">
    <div class="kanban-columns">
      @for (col of cols; track trackByColumn($index, col)) {
      <div class="kanban-col" cdkDropList [id]="col.key" [cdkDropListData]="data[col.key]" (cdkDropListDropped)="drop.emit({ event: $event, target: col.key })">
        <div class="kanban-col-header">
          <span class="dot" [style.background]="col.hintColor"></span>
          <span class="title">{{ col.title }}</span>
        </div>
        <div class="kanban-col-body">
          @if (!data[col.key]?.length) {
          <div class="kanban-empty">
            <i nz-icon [nzType]="col.icon || 'inbox'"></i>
            <div>No hay catálogos</div>
          </div>
          } @for (row of data[col.key]; track trackByRow($index, row)) {
          <div class="kanban-card" cdkDrag>
            <div class="kc-head">
              <div class="kc-title">{{ row.name }}</div>
              <i nz-icon nzType="more"></i>
            </div>
            <div class="kc-lines">
              @if (showProvider) {
              <div class="kc-line">
                <i nz-icon nzType="database"></i>
                <span>{{ row.provider }}</span>
              </div>
              } @if (showDates && row.receivedAt) {
              <div class="kc-line">
                <i nz-icon nzType="calendar"></i>
                <span>{{ row.receivedAt }}</span>
              </div>
              } @if (showDates && row.publishedAt) {
              <div class="kc-line">
                <i nz-icon nzType="calendar"></i>
                <span>{{ row.publishedAt }}</span>
              </div>
              }
            </div>
            @if (showQuickActions) {
            <div class="kc-actions">
              @if (row.state==='PEND_IMPORT') {
              <button
                type="button"
                type="button"
                nz-button
                nzSize="small"
                class="kc-btn kc-btn--primary"
                nz-popover
                [nzPopoverTitle]="'Detalles de asignaciones:'"
                [nzPopoverContent]="assignTpl"
                nzPopoverTrigger="click"
                (click)="clickAssign.emit(row)"
              >
                <i nz-icon nzType="user-add"></i> Asignar
              </button>
              } @if (row.state!=='PEND_IMPORT') {
              <button type="button" type="button" nz-button nzSize="small" class="kc-btn" (click)="clickEdit.emit(row)"><i nz-icon nzType="edit"></i> Editar</button>
              }
            </div>
            }
          </div>
          }
        </div>
      </div>
      }
      <!-- /kanban-col -->
    </div>
  </div>
</div>
